/**
 * Document Reader Service
 * Handles file uploads to backend for text extraction
 */

import apiClient from './apiClient';

const apiBaseURL = '/documents/';

export interface DocumentReadResponse {
  success: boolean;
  content: string;
  filename: string;
  file_type: string;
  error?: string;
  character_count: number;
  word_count: number;
}

export interface SupportedTypesResponse {
  supported_extensions: string[];
  supported_mime_types: string[];
  description: string;
}

/**
 * Upload a document and extract its text content
 */
export async function readDocument(file: File): Promise<DocumentReadResponse> {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post<DocumentReadResponse>(
    `${apiBaseURL}read`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data;
}

/**
 * Get list of supported document types
 */
export async function getSupportedTypes(): Promise<SupportedTypesResponse> {
  const response = await apiClient.get<SupportedTypesResponse>(`${apiBaseURL}supported-types`);
  return response.data;
}

/**
 * Read a document that is already stored in the backend (MinIO-backed).
 * Uses the dedicated /documents/read-from-document/{id} endpoint.
 */
export async function readStoredDocument(documentId: string | number): Promise<DocumentReadResponse> {
  const response = await apiClient.post<DocumentReadResponse>(`${apiBaseURL}read-from-document/${documentId}`);
  return response.data;
}

export default {
  readDocument,
  getSupportedTypes,
  readStoredDocument,
};
